import { useFragment, useLazyLoadQuery, useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import type { appBuildNumber_AppVersionFragment$key } from "@relay/appBuildNumber_AppVersionFragment.graphql";
import type { appBuildNumber_Query } from "@relay/appBuildNumber_Query.graphql";
import type { appBuildNumber_setAppBuildNumbersMutation } from "@relay/appBuildNumber_setAppBuildNumbersMutation.graphql";
import {
	QUERY,
	APP_VERSION_FRAGMENT,
	SET_APP_BUILD_NUMBER_MUTATION,
} from "./app-build-number.graphql";
import { AppBuildNumberForm } from "./parts/app-build-number-form";
import type { AppBuildNumberFormValues } from "./parts/app-build-number-form/app-build-number-form.types";
import { BaseScreen } from "../../components/base-screen";
import { colorError100Class } from "../../themes/color-classes";
import { P2Span } from "../../themes/font-tags";

export const AppBuildNumberScreen = () => {
	const { t } = useTranslation("common");

	const query = useLazyLoadQuery<appBuildNumber_Query>(QUERY, {});

	const data = useFragment<appBuildNumber_AppVersionFragment$key>(
		APP_VERSION_FRAGMENT,
		query.Admin.App.GetAppBuildNumbers,
	);

	const [setAppBuildNumbers] = useMutation<appBuildNumber_setAppBuildNumbersMutation>(
		SET_APP_BUILD_NUMBER_MUTATION,
	);

	const handleAppBuildNumberSubmit = (values: AppBuildNumberFormValues) => {
		setAppBuildNumbers({
			variables: {
				input: {
					iosBuildNumber: values.iosBuildNumber,
					androidBuildNumber: values.androidBuildNumber,
				},
			},
			onCompleted: () => {
				toast.success(t("appBuildNumber.successMessage"));
			},
		});
	};

	return (
		<BaseScreen title={t("appBuildNumber.title")}>
			<div>
				<P2Span>{t("appBuildNumber.forceUpdateWarning")}</P2Span>
				<br />
				<P2Span className={colorError100Class}>
					{t("appBuildNumber.forceUpdateError")}
				</P2Span>
				<br />
				<P2Span>{t("appBuildNumber.recommendation")}</P2Span>
			</div>
			<AppBuildNumberForm initialValues={data} onSubmit={handleAppBuildNumberSubmit} />
		</BaseScreen>
	);
};
